import _ from 'lodash';

import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';

import Wix from '../services/wix-sdk-polyfill';
import { eventMapUoU, eventMapUsers } from '../services/bi-events-map';
import { isSocial, getAppComponent, getOriginalAppComponent, getAppDefId, getViewMode } from '../state/site/selectors';
import { getViewedMember } from '../state/members/selectors';
import { getPageType } from '../state/ff-page/selectors';
import { FOLLOWING_FOLLOWERS } from '../constants/app-components';
import { getConfig } from '../services/config';
import { VIEW_MODE_SITE } from '../constants/view-modes';

const getBIAppName = (state) => {
  const appComponent = getOriginalAppComponent(state) || getAppComponent(state);
  return appComponent === FOLLOWING_FOLLOWERS ? getPageType(state) : appComponent;
};

export const getBIAppData = (state) => {
  const id = getAppDefId(state);
  const name = getBIAppName(state);
  return name ? { id, name } : { id: '', name: '404' };
};

const createBiLogger = (endpoint) =>
  iframeAppBiLoggerFactory(Wix, { endpoint, host: getConfig().biServerHost }).updateDefaults({ src: 69 }).logger();

const maybeLog = ({ action, store, biLogger, defaultsFx, map }) => {
  const transformFx = map[action.type];
  if (!transformFx) {
    return;
  }

  const state = store.getState();
  const event = transformFx(action, state);
  if (!event) {
    return;
  }

  const promise = biLogger.log(defaultsFx(event, state));
  // eslint-disable-next-line no-console
  promise.catch((e) => console.log('BI logger error', e, event));
};

const extendDefaults = (event, state) => ({
  app_id: getBIAppData(state).id,
  biToken: Wix.Utils.getInstanceValue('biToken') || '',
  instance_id: Wix.Utils.getInstanceId() || '',
  is_social: isSocial({ site: state.site }) ? 1 : 0,
  member_id: '',
  site_member_id: '',
  visitor_id: '',
  _: new Date().getTime(),
  ...event,
});

const extendDefaultsUoU = (event, state) => {
  const currentMember = getViewedMember(state) || { permissions: {} };
  return {
    ...extendDefaults(event, state),
    member_id: currentMember?.uid || null,
    role: _.first(currentMember.roles) || '',
    site_member_id: Wix.Utils.getInstanceValue('uid') || '',
    visitor_id: Wix.Utils.getInstanceValue('aid') || Wix.Utils.getInstanceValue('uid'),
  };
};

/**
 * App UoU only (not editor/preview) - public app
 */
export function biMiddlewareUoU(store) {
  const biLogger = createBiLogger('members-app-uou');
  return (next) => (action) => {
    const viewMode = getViewMode(store.getState());
    if (viewMode === VIEW_MODE_SITE) {
      maybeLog({
        action,
        store,
        biLogger,
        defaultsFx: extendDefaultsUoU,
        map: eventMapUoU,
      });
    }
    return next(action);
  };
}

/**
 * App settings only - website owner
 */
export function biMiddlewareUsers(store) {
  const biLogger = createBiLogger('members-app-users');
  return (next) => (action) => {
    maybeLog({
      action,
      store,
      biLogger,
      defaultsFx: extendDefaults,
      map: eventMapUsers,
    });
    return next(action);
  };
}
